<template>
  <div class="filter-container-left mb-6 w-2/5">
    <label for="broker-select" class="block text-gray-700">
      Selecione uma Corretora:
    </label>
    <PermissionedAutocomplete
      source="broker"
      permission-subject="Dashboard"
      :multiple="false"
      include-all-brokers-option
      placeholder="Escolha a corretora"
      class="block mt-2"
      v-model="selectedCorretora"
      @input="handleCorretoraChange"
    />
  </div>
</template>

<script>
import PermissionedAutocomplete from '../../components/filtros/PermissionedAutocomplete.vue';

export default {
  components: {
    PermissionedAutocomplete,
  },
  data() {
    return {
      selectedCorretora: null,
    };
  },
  methods: {
    handleCorretoraChange(corretora) {
      this.$emit('brokerSelected', corretora ? corretora.id : null);
    },
  },
};
</script>
